import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("h1", null, "Connection Lost", -1 /* HOISTED */);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", null, "Please check your internet connection!", -1 /* HOISTED */);
const _hoisted_3 = [
    _hoisted_1,
    _hoisted_2
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, _hoisted_3));
}
